/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import * as yup from 'yup';

export const getYupFieldType = (field: string): any => {
  switch (field) {
    case 'text':
      return yup.string();
    case 'list':
      return yup.string();
    case 'boolean':
      return yup.boolean();
    case 'number':
      return yup
        .number()
        .transform(cv => (isNaN(cv) ? undefined : cv))
        .positive()
        .integer();

    case 'date':
      return yup
        .date()
        .nullable()
        .default(() => new Date());

    default:
      return yup.string();
  }
};

// Create our number formatter.
export const currencyFormatter = (number: any) => {
  if (number === undefined || number === null) return ""; // Return an empty string if number is undefined or null
  const val = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  });
  return val.format(number);
};

export const USPhoneNumberFormat = (phoneNumberString: string | undefined) => {
  return phoneNumberString;
  // const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  // const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  // if (match) {
  //   const intlCode = match[1] ? '+1 ' : '';
  //   return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  // }
  // return null;
};

export const getYupValidationByField = (
  fieldName: string,
  validationObj: any,
  schema: any
) => {
  const validationsArray = Object.keys(validationObj);
  if (
    validationsArray.includes('max_length') &&
    validationsArray.includes('min_length')
  ) {
    const isBothSame = validationObj.min_length === validationObj.max_length;
    if (isBothSame) {
      schema = schema.test(
        'len',
        `${fieldName} should be of length ${validationObj.min_length}`,
        (val: any) => {
          return val?.toString().length === validationObj.max_length;
        }
      );
      return schema;
    } else {
      schema = schema.test(
        'len',
        `${fieldName} length should be between ${validationObj.min_length} and ${validationObj.max_length}`,
        (val: any) => {
          if (val == undefined) {
            return true;
          }
          return (
            val.length == 0 ||
            (val.length >= validationObj.min_length &&
              val.length <= validationObj.max_length)
          );
        }
      );
      return schema;
    }
  } else if (validationsArray.includes('max_length')) {
    schema = schema.test(
      'len',
      `${fieldName} max length is ${validationObj.max_length}`,
      (val: any) => {
        if (val == undefined) {
          return true;
        }
        return val.length == 0 || val.length <= validationObj.max_length;
      }
    );
    return schema;
  } else if (validationsArray.includes('min_length')) {
    schema = schema.test(
      'len',
      `${fieldName} min length is ${validationObj.min_length}`,
      (val: any) => {
        if (val == undefined) {
          return true;
        }
        return val.length == 0 || val.length >= validationObj.min_length;
      }
    );
    return schema;
  }
};

export const FieldNamesMapping: any = {
  first_name: 'First Name',
  last_name: 'Last Name',
  name: 'Name',
  mrn_no: 'MRN No',
  dob: 'Date of Birth',
  social_security_number: 'Social Security Number',
  system_name: 'System Name',
  po_number: 'PO Number',
  requisition_number: 'Requisition Number'
};

export const getSearchFormFieldParams = (params: any): string => {
  let queryParams = '';

  Object.entries(params).forEach((item, index) => {
    if (item && item[1]) {
      queryParams =
        queryParams + `${index === 0 ? '' : '&&'}${item[0]}=${item[1]}`;
    }
  });

  return queryParams;
};

export const getCompleteUrl = ({
  offset,
  limit,
  sort_type,
  sort_column,
  legacy_system
}: any): string => {
  let optionalParamsUrl = '';
  optionalParamsUrl = optionalParamsUrl + `&&offset=${offset || 0}`;
  optionalParamsUrl = optionalParamsUrl + `&&limit=${limit}`;
  optionalParamsUrl = optionalParamsUrl + `&&sort_type=${sort_type}`;
  optionalParamsUrl = optionalParamsUrl + `&&sort_column=${sort_column}`;
  optionalParamsUrl = optionalParamsUrl + `&&legacy_system=${legacy_system}`;
  return optionalParamsUrl;
};
